import { isQuotaLimitReachedError } from "@lazarentertainment/public-chat-web"
import { usePublicChatContext } from "@lazarentertainment/public-chat-web/dist/src/react"

import { useChatContext } from "./ChatContext"
import DeleteMessageErrorModal from "./DeleteMessageErrorModal"
import JoinChatModal from "./JoinChatModal"
import QuotaLimitReachedErrorModal from "./QuotaLimitReachedErrorModal"

export type MobileChatModalLayerProps = {
  focusMainChatInput: () => void
}

export const MobileChatModalLayer = ({
  focusMainChatInput,
}: MobileChatModalLayerProps) => {
  const {
    writeReady,
    setIsChatOpen,
    isJoinModalOpen,
    setIsJoinModalOpen,
    chatError,
    clearChatError,
  } = useChatContext()
  const { quotaRefreshSecondsRemaining } = usePublicChatContext()
  return (
    <>
      {isQuotaLimitReachedError(chatError) && (
        <QuotaLimitReachedErrorModal
          refreshTime={quotaRefreshSecondsRemaining}
          closeModal={clearChatError}
        />
      )}
      {chatError && chatError.code === "DeleteMessageError" && (
        <DeleteMessageErrorModal closeModal={clearChatError} />
      )}
      {isJoinModalOpen && (
        <JoinChatModal
          focusMainChatInput={focusMainChatInput}
          onClose={() => {
            setIsJoinModalOpen(false)
            clearChatError()

            if (!writeReady) {
              setIsChatOpen(false)
            }
          }}
        />
      )}
    </>
  )
}
